import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { ChargeService } from 'src/app/services/charge/charge.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { SettingService } from 'src/app/services/setting/setting.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cal-custom-clearance',
  templateUrl: './cal-custom-clearance.component.html',
  styleUrls: ['./cal-custom-clearance.component.scss']
})
export class CalCustomClearanceComponent extends DestructorComponent implements OnInit {

  customClearanceForm!: FormGroup;
  isLoading = false;
  data: any;
  settingId: string = '';

  constructor(
    private fb: FormBuilder,
    private _chargeService: ChargeService,
    private _globalService: GlobalStateService,
    private _settingService: SettingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeForm();
    this.GetData();
  }

  private initializeForm(): void {
    this.customClearanceForm = this.fb.group({
      name: ['Custom Clearance'],
      passenger_car_suv_van: ['', [Validators.required, Validators.min(0)]],
      truck: ['', [Validators.required, Validators.min(0)]],
      type: ['custom-clearance'] // Hidden field with default value
    });
  }

  // Getter methods for form controls
  get passengerCarSuvVan() {
    return this.customClearanceForm.get('passenger_car_suv_van');
  }

  get truck() {
    return this.customClearanceForm.get('truck');
  }

  GetData(): void {
    this.subscriptions.push(
      this._globalService.GetSetting().subscribe((res: any) => {
        this.data = res.custom_clearance_charges;
        this.settingId = res._id;
        console.log(this.data);

        // Populate form with existing data
        if (this.data) {
          this.customClearanceForm.patchValue({
            passenger_car_suv_van: this.data.passenger_car_suv_van || '',
            truck: this.data.truck || '',
          });
        }
      })
    );
  }

  onSubmit(): void {
    if (this.customClearanceForm.valid && !this.isLoading) {
      this.isLoading = true;

      const formData = this.customClearanceForm.value;

      const submitData = {
        "custom_clearance_charges": {
          passenger_car_suv_van: formData.passenger_car_suv_van,
          truck: formData.truck,
          type: formData.type
        }
      };

      // Remove empty fields
      // const submitData: any = {};
      // Object.keys(formData).forEach(key => {
      //   if (formData[key] !== null && formData[key] !== '') {
      //     submitData[key] = formData[key];
      //   }
      // });

      this.subscriptions.push(
        this._settingService.UpdateData(this.settingId, submitData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            console.log('Proforma settings updated successfully:', response);

            this._globalService.SetSetting();
            // Show success message
            Swal.fire({
              text: "Custom Clearance Charges have been successfully updated!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            }).then((result: any) => {
            });
          },
          error: (error: any) => {
            this.isLoading = false;
            console.error('Error updating Custom Clearance Charges:', error);

            // Show error message
            Swal.fire({
              text: "Sorry, looks like there are some errors detected, please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        })
      );
    }
  }

  private resetForm(): void {
    this.customClearanceForm.reset({
      passenger_car_suv_van: 0,
      truck: 0,
      type: 'custom-clearance'
    });
  }
}
